export const socialStyles = {
  wrapper: {
    mt: {
      mobile: "1.25rem",
      tablet: "unset",
    },
  },
  iconStyle: {
    margin: "0 0.4rem",
    padding: 0,
  },
};
